<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<main class="judgements" [hidden]="spinner">
  <header class="judgements--header">
    <div class="judgements--header__container">
      <h5 class="judgements--header__title">
        {{ 'judgementsRequest' | i18next }}
      </h5>
      <div id="stepperHeader"></div>
    </div>
  </header>
  <app-stepper
    [user]="user"
    [requestType]="requestTypeEnum.judgements"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
  ></app-stepper>
</main>
